import { useState } from "react";
import "./index.css";
import Loader from "../../../../Loader/Index";
import { cloudKeyList } from "../../../../../redux/features/byok/byok";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import UniversalRefreshToast from "../../../../_utils/UniversalRefreshToast";
import TEXT from "../../../../../utils/globalText";
import PrimaryButton from "../../../../_utils/CommonButtons/PrimaryButton";
import CommonToast from "../../../../_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";

const ChangeKeyPopup = ({
  changeKeyPop,
  setChangeKeyPop,
  setBankingSelected,
  setSelectKey,
  setActiveStep,
  setCurrentDisplay,
  fetchCreadentials,
  isRotatingKeys,
  setisRotatingKeys,
  setRotatingKey,
  encryptedKey,
  setCredentialsFocus,
  setCredentials,
  // setShowToast,
}) => {
  const [timeOutSD, setTimeOutSD] = useState(false);

  const dispatch = useDispatch();

  const { cloudKeyListData } = useSelector((state) => state.byok);

  return (
    <div
      className={`byok-encryp-conf-popup w-small-popup-width ${changeKeyPop ? "popup-show" : ""}`}
    >
      <div className="flex flex-col gap-gap-xs mb-margin-xl">
        <h2 className="text-Header-orange font-semibold text-xl">
          {TEXT?.CHANGE_KEY}
        </h2>
        <p className="font-normal text-text-primary text-sm">
          {TEXT?.CONFIRM_CHANGE_KEY}
        </p>
      </div>
      <div className="flex gap-gap-md justify-end w-full">
        <>
          {!timeOutSD && (
            <PrimaryButton
              btnText={TEXT?.CANCEL}
              btnType="button"
              handleFunction={() => setChangeKeyPop(false)}
              enabledBgColor="var(--primary-card)"
              enabledTextColor="var(--text-primary)"
              disabledTextColor="var(--text-primary)"
              hoverOption="white"
              outLineColor={"var(--text-primary)"}
            />
          )}
          {timeOutSD ? (
            <Loader />
          ) : (
            <PrimaryButton
              btnText={TEXT?.CONFIRM}
              btnType="button"
              handleFunction={() => {
                setTimeOutSD(true);
                // setShowToast(true);
                // toast.info("fetching", toast_position)
                UniversalRefreshToast("Fetching keys");
                setTimeout(() => {
                  // setShowToast(false);
                  setChangeKeyPop(false); // move this here so popup doesn't disappear immediately
                  setTimeOutSD(false);
                  fetchCreadentials();
                  dispatch(cloudKeyList());
                  setBankingSelected(false);
                  setSelectKey("");
                  setCurrentDisplay("BYOKstepperPage");

                  setRotatingKey(encryptedKey);
                  setisRotatingKeys(true);
                  toast.dismiss();

                  if (
                    Object.keys(cloudKeyListData || {}).includes("keys") &&
                    cloudKeyListData.keys.length > 0
                  ) {
                    CommonToast({
                      text: "Keys fetched successfully.",
                      icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
                      variant: "var(--success)",
                      btnProps: {
                        isDisabled: false,
                        enabledTextColor: "var(--text-primary)",
                        enabledBgColor: "var(--primary-bg)",
                      },
                    });
                    setActiveStep(1);
                  } else {
                    setActiveStep(0);
                    setCredentials((prev) => {
                      return {
                        region: "",
                        access_key: "",
                        secret_access_key: "",
                        session_token: "",
                        platform: "aws",
                      };
                    });
                    CommonToast({
                      text: "Unable to fetch keys, kindly verify credentials",
                      icon: ICONS?.ERROR_WHITE_CIRCLE,
                      variant: "var(--error)",
                      buttonNeeded: false,
                    });
                  }
                }, 3000);
              }}
              enabledBgColor="var(--Button-green)"
              disabledBgColor="var(--text-secondary)"
              enabledTextColor="var(--text-primary)"
              disabledTextColor="var(--text-primary)"
              hoverOption="white"
            />
          )}
        </>
      </div>
    </div>
  );
};

export default ChangeKeyPopup;
